import { Popover } from 'bootstrap';
import { jsGlobalVars } from '@frontend/components/settings';

$.fn.olm2PopoverInfo = function (opt, onlyTr) {
    const self = this; // Ha true, akkor csak akkor jelenik meg, ha nem fér ki a szöveg

    const options = {
        placement: 'top',
        fallbackPlacements: ['top'],
        container: 'body',
        trigger: 'hover',
        html: true,
        sanitize: false,
    };

    let onlyTruncated;

    self.init = () => {
        let o;
        if (typeof onlyTr == 'undefined') {
            // Ha nem adjuk meg, akkor true
            onlyTruncated = true;
        } else {
            onlyTruncated = onlyTr;
        }
        $.extend(options, opt);
        self.each(function () {
            const that = $(this);
            let hide = false;
            let forced = false;
            let hideWhat = that;
            let visibility;

            if (that.is(':hidden')) {
                // Ha a mező el van rejtve, akkor átállítjuk, hogy a visibility legyen hidden, mert különben nem lehet rátenni a popovert
                if (that.css('display') == 'none') {
                    visibility = that.css('visibility');
                    that.css({
                        visibility: 'hidden',
                        display: 'initial',
                    });
                } else {
                    // Ugyanúgy, ha bármelyik szülő objektum el van rejtve, akkor átállítjuk
                    that.parents().each(function () {
                        visibility = $(this).css('visibility');
                        if ($(this).css('display') == 'none') {
                            $(this).css({
                                visibility: 'hidden',
                                display: 'initial',
                            });
                            hideWhat = $(this); // Ekkor a szülőt kell elrejteni újból
                        }
                    });
                }
                hide = true;
            }
            // Mezőnként lehet kényszeríteni, hogy mindenképp megjelenjen a popover
            if (that.data('forced') == true) {
                forced = true;
            }

            // Ha nem csak a truncated cuccokra kell, vagy kényszerítve van, vagy nem fér ki, akkor rátesszük a popovert
            if (
                !onlyTruncated ||
                forced ||
                this.scrollWidth > this.clientWidth ||
                this.scrollHeight > this.clientHeight
            ) {
                const content = $(this).data('content');
                // Ha nincs megadva a data-content, akkor a mezőben lévő szöveget kapja meg
                if (typeof options.content == 'undefined' && !content) {
                    o = $.extend({}, options, { content: $(this).text() });
                } else {
                    o = $.extend({}, options, {
                        content: options.content ?? content,
                    });
                }
                // eslint-disable-next-line no-magic-numbers
                const popover = new Popover(this, o);
            }
            // Ha rejtve volt, akkor visszaállítjuk a displayt és a visibilityt
            if (hide) {
                hideWhat.css({
                    visibility,
                    display: 'none',
                });
            }
        });
    };

    // Kívülről meghívható, elrejti a popovert
    self.hide = () => {
        self.each(function () {
            Popover.getInstance(this)?.hide();
        });
    };

    // Kívülről meghívható, törli a popovert
    self.destroy = () => {
        self.each(function () {
            Popover.getInstance(this)?.dispose();
        });
    };

    self.init();
    return self;
};
